module.exports = __webpack_public_path__ + "static/media/technology.c2dc8466.png";